import * as React from "react"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import { observable } from "mobx"
import { observer } from "mobx-react"
import AddPaymentMethodForm from "./AddPaymentMethodForm"
import PaymentMethodList from "./PaymentMethodList"
import MembershipsList from "./MembershipsList"
import ActiveMembership from "./ActiveMembership"
import RequirePermission, { Permission } from "./RequirePermission"
import MemberBillingHistory from "./MemberBillingHistory"
import { EventBusContext } from "../common/EventBus"
import ManageMembershipRenewal from "./system/members/ManageMembershipRenewal"

type Props = {
  memberId: number
  onMemberInvalidated: () => void
}

@observer
export default class MemberBilling extends React.Component<Props, never> {
  static contextType = EventBusContext
  context!: React.ContextType<typeof EventBusContext>

  @observable
  private showModal = false
  @observable
  private editModalContent?: React.ReactNode
  @observable
  private editModalSize = 'lg'
  @observable
  private editModalTitle = 'Edit'

  private showEditModal = (title: string, component: React.ReactNode, size: string = 'lg') => {
    this.editModalTitle = title
    this.editModalContent = component
    this.showModal = true
    this.editModalSize = size
  }

  private closeEditModal = () => {
    this.showModal = false
    this.editModalContent = undefined
  }

  render (): React.ReactNode {
    return <>
      <ActiveMembership
        memberId={this.props.memberId}
      />

      <RequirePermission permission={Permission.ManageMembership} context={{ memberId: this.props.memberId }}>
        {() => <div>
          <hr/>
          <h5 className="text-muted">Membership Renewal</h5>
          <ManageMembershipRenewal
            memberId={this.props.memberId}
          />
        </div>}
      </RequirePermission>

      <MembershipsList memberId={this.props.memberId}/>

      <RequirePermission permission={Permission.ViewMemberPaymentMethods} context={{ memberId: this.props.memberId }}>
        {() => <>
          <hr/>

          <h5 className="text-muted">Payment Methods</h5>
          <PaymentMethodList
            memberId={this.props.memberId}
          />
          <Button type="button" color="primary" onClick={() => this.showEditModal('Add Payment Method', <AddPaymentMethodForm memberId={this.props.memberId} onCancel={this.closeEditModal} onSaved={() => {
            this.closeEditModal()
            this.context.eventBus.dispatch('member-invalidated')
          }}/>, 'md')}>Add Payment Method</Button>
        </>}
      </RequirePermission>

      <RequirePermission permission={Permission.ViewMemberBilling} context={{ memberId: this.props.memberId }}>
        {() => <div>
          <hr/>
          <h5 className="text-muted">Billing History</h5>
          <MemberBillingHistory
            memberId={this.props.memberId}
          />
        </div>}
      </RequirePermission>

      <Modal
        isOpen={this.showModal}
        size={this.editModalSize}
      >
        <ModalHeader toggle={this.closeEditModal}>
          {this.editModalTitle}
        </ModalHeader>
        <ModalBody>{this.editModalContent}</ModalBody>
      </Modal>
    </>
  }
}